import React, { useCallback } from "react";
import { Field } from "redux-form";
import buildFormField from "./buildFormField";
import memoize from "fast-memoize";
import CreditCardInput from "./CreditCardInput";
import { cardNumberFormatter } from "../../../utils/cardFormatters";

const FormField = buildFormField(CreditCardInput, (input, meta, rest) => {
  return {
    ...input,
    autoComplete: "off",
    ...rest,
    invalid: `${meta.touched && (meta.invalid || rest.invalid)}`,
  };
});

let id = 0;
function memoizedId(x) {
  if (!x.__memoizedId) x.__memoizedId = ++id;
  return { __memoizedId: x.__memoizedId };
}

// this needs to be memoizable!
const buildValidator = memoize(
  (required, other) => {
    return [
      (value) => {
        if (required && !value) {
          return "required";
        }
        return undefined;
      },
    ].concat(other || []);
  },
  {
    serializer: (args) => {
      const argumentsWithFuncIds = Array.from(args).map((x) => {
        if (typeof x === "function") return memoizedId(x);
        return x;
      });
      return JSON.stringify(argumentsWithFuncIds);
    },
  }
);

export default function CreditCardField(props) {
  const { required, validate, ...attrs } = props;
  const normalize = useCallback((value) => value?.replace(/[^0-9]+/g, ""), []);
  const format = useCallback((value) => cardNumberFormatter(value), []);

  return (
    <Field
      {...attrs}
      required={required}
      component={FormField}
      normalize={normalize}
      format={format}
      validate={buildValidator(required, validate)}
    />
  );
}
